import { AuthorizationStatusEnum, type TLocationSettingsType } from '../../../types/tracking'

interface IMobileTrackingIssueLabelsParams {
  isDeviceNotDetected?: boolean
  isLoggedIn?: boolean
  isTrackingOn?: boolean
  locationSettings: TLocationSettingsType | null
}

/**
 * Build concise issue labels for the mobile tracking source summary row.
 */
export const getMobileTrackingIssueLabels = ({
  isDeviceNotDetected,
  isLoggedIn,
  isTrackingOn,
  locationSettings
}: IMobileTrackingIssueLabelsParams): string[] => {
  const labels = new Set<string>()

  const hasPermissionIssue =
    !!locationSettings?.authorizationStatus &&
    locationSettings.authorizationStatus !== AuthorizationStatusEnum.AuthorizationStatusAlways
  const hasLocationServicesIssue = locationSettings?.locationServicesEnabled === false
  const hasGPSProviderIssue = locationSettings?.gpsGeolocationProviderAvailable === false

  if (hasPermissionIssue || hasLocationServicesIssue || hasGPSProviderIssue) {
    labels.add('GPS disabled')
  }

  if (isLoggedIn === false) {
    labels.add('Logged out')
  }

  if (isTrackingOn === false) {
    labels.add('Off duty')
  }

  if (isDeviceNotDetected) {
    labels.add('Device not detected')
  }

  return Array.from(labels)
}
